import { NextPage } from 'next';
import { layouts } from 'constants/layouts';
import { Stack, Text, Box } from '@chakra-ui/react';
import ContactLink from 'components/Contact/ContactLink';
import ContactView from 'components/Contact/ContactView';
import ContactHeader from 'components/Contact/ContactHeader';
import { paths } from 'constants/paths';
import DefaultHead from '../../components/DefaultHead';

const ContactDetailPages = [
  {
    title: 'パッケージに関するお問い合わせ',
    href: paths.contactPackage,
  },
  {
    title: 'その他',
    href: paths.contactOther,
  },
];

export const getStaticProps = async () => ({
  props: {
    layout: layouts.contact,
  },
});
const Index: NextPage = () => (
  <ContactView>
    <ContactHeader />
    <DefaultHead
      title="問い合わせ - shizai"
      description="shizaiはオリジナルパッケージを低コスト・高品質で作れるプラットフォームです。ECで必要なパッケージの見積もりをかんたんに取得できます。"
      url={process.env.ORIGIN + paths.contact}
    />
    <Box marginTop="3rem" />
    <Text textStyle="body2" color="primary.500">
      お問い合わせいただきありがとうございます。以下より選択肢をお選びください。
    </Text>
    <Box marginY="2rem">
      <Text textStyle="subtitle">お問い合わせ内容</Text>
    </Box>
    <Stack spacing="2rem">
      {ContactDetailPages.map((page) => (
        <ContactLink key={page.href} {...page} />
      ))}
    </Stack>
  </ContactView>
);

export default Index;
